import { CSSProperties, useEffect, useRef, useState } from 'react'

export function MarqueeText({
  text,
  hovered,
  className,
  style
}: {
  text: string
  hovered: boolean
  className?: string
  style?: CSSProperties
}) {
  const outerRef = useRef<HTMLSpanElement>(null)
  const innerRef = useRef<HTMLSpanElement>(null)
  const shiftRef = useRef(0)
  const [shift, setShift] = useState(0)
  const [opacity, setOpacity] = useState(1)
  const [animated, setAnimated] = useState(true)

  useEffect(() => {
    if (hovered) {
      const outer = outerRef.current
      const inner = innerRef.current
      const next = outer && inner ? Math.min(0, outer.clientWidth - inner.scrollWidth) : 0
      shiftRef.current = next
      setAnimated(true)
      setOpacity(1)
      setShift(next)
      return
    }

    if (shiftRef.current === 0) return

    setOpacity(0)
    const timer = window.setTimeout(() => {
      shiftRef.current = 0
      setAnimated(false)
      setShift(0)
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          setAnimated(true)
          setOpacity(1)
        })
      )
    }, 200)
    return () => window.clearTimeout(timer)
  }, [hovered])

  return (
    <span
      ref={outerRef}
      className={className}
      style={{ display: 'block', overflow: 'hidden', whiteSpace: 'nowrap', ...style }}
    >
      <span
        ref={innerRef}
        style={{
          display: 'inline-block',
          transform: `translateX(${shift}px)`,
          opacity,
          transition: animated
            ? `transform ${Math.abs(shift) * 30}ms linear, opacity 200ms ease`
            : 'none'
        }}
      >
        {text}
      </span>
    </span>
  )
}
